import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { first, shareReplay } from 'rxjs';
import { Table } from 'primeng/table';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { DatePipe } from '@angular/common';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-stp-target',
  templateUrl: './stp-target.component.html',
  styleUrls: ['./stp-target.component.scss'],
  providers: [DatePipe],
})
export class StpTargetComponent implements OnInit {

  @ViewChild('canalMasterTable', { static: true })
  public canalMasterTable: Table;

  public userId: any;
  public canalMasterData: any = [];
  public subscriptions: any = []
  public subjectSub: any;
  public selectedYear: any;
  public loading: boolean = false;
  public ipAddress: any;
  public showDialog: boolean = false;
  submitEstimateForm: FormGroup;
  public showDialogToUpdateStatus: any;
  public selectedOutlet: any;
  public isSubmitted: boolean = false;
  updateStatusForm: FormGroup;
  menuItems: MenuItem[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  appVerificationItems: MenuItem[];
  // appVerificationItems: MenuItem[];
  // cols: (
  //   | { field: string; header: string; customExportHeader: string }
  //   | { field: string; header: string; customExportHeader?: undefined }
  // )[];
  // exportColumns: { title: string; dataKey: string }[];

  constructor(
    private service: BaseService,
    private activityRecordService: ActivityRecordService,
    private deptDashBoardService: DepartmentDashboardService,
    private messageService: MessageService,
    private ipService: IpAddressService,
    private confirmationService: ConfirmationService,
    private loader: AppLoaderService,
    private _personalDetalSer: FarmersDetailsService, 
    private _fb: FormBuilder,
    private datePipe: DatePipe,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    this.loadDataAndApplyFilter();

    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.canalMasterData, "STP Report");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.canalMasterData, "STP Report");
      //   }
      // },
    ];
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.canalMasterData, "STP Report");
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.canalMasterData, "STP Report");
      //   }
      // },
    ];
    this.updateStatusForm = this._fb.group({
      documentID: ['', Validators.required],     
      documentPath: ['', Validators.required],
      fromDate: ['', Validators.required],
      endDate: ['', Validators.required],
      area: ['', Validators.required],
    });
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  get updateStatusFormControls() {
    return this.updateStatusForm.controls;
  }

  loadDataAndApplyFilter() {
    if (sessionStorage.getItem('financialYear')) {
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {


        this.selectedYear = res;
        this.loadData();
        // this.canalMasterTable.filters['FinYear'] = [
        //   { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  loadData() {
    this.getIP();
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    // this.vendorRegId = JSON.stringify(token?.officeCode);

    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getOutletMasterForCanal()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Outlet Master For Canal', '', new Date(), 'Success');

          this.userId = JSON.parse(payload)?.sub;

          // data = JSON.parse(data)
          if (data.length > 0) {
            this.canalMasterData = data;
            this.canalMasterData = this.canalMasterData.filter((val) => val?.Type == 'STP');
            if(this.canalMasterData.length == 0){
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
            }
          }
          else {
            this.canalMasterData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
        },
        error: (err) => {
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Outlet Master For Canal', '', new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

 
  updateAction(val) {
    // let textVal = val?.CurrentStatus == 'Open' ? 'close' : 'open';
    // this.confirmationService.confirm({
    //   message: `<b>Want to ${textVal} for ${val?.WaterCourse_Name}?</b>`,
    //   header: 'Confirm',
    //   icon: 'pi pi-exclamation-triangle',
    //   accept: () => {
    //     let reqBody = {
    //       AutoId: val?.Auto_ID,
    //       Status: val?.CurrentStatus == 'Open' ? 0 : 1,
    //       NetworkId: this.ipAddress,
    //       TerminalId: this.ipAddress
    //     }
    //     this.updateOutletStatus(reqBody);
    //   }
    // });
    this.selectedOutlet = val;
    this.showDialogToUpdateStatus = true;
  }

  hideDialog(){
    this.showDialogToUpdateStatus = false;
    this.isSubmitted = false;
    this.updateStatusForm.reset();
  }

  saveProduct(){
    this.isSubmitted = true;
    if (this.updateStatusForm.valid) {
      let val = this.updateStatusForm.value;
      let reqBody = {
        AutoId: this.selectedOutlet?.Auto_ID,
        Status: this.selectedOutlet?.Status == 'Open' ? 0 : 1,
        documentPath: val?.documentPath,
        documentID: val?.documentID,
        fromDate: val.fromDate ? this.datePipe.transform(new Date(val.fromDate), 'yyyy-MM-dd') : val.fromDate,
        endDate: val.endDate ? this.datePipe.transform(new Date(val.endDate), 'yyyy-MM-dd') : val.endDate,
        area: val?.area,
        NetworkId: this.ipAddress,
        TerminalId: this.ipAddress
      }
      this.updateOutletStatus(reqBody);
    }
    
  }

  updateOutletStatus(reqBody) {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.loader.start();
    this.deptDashBoardService
      .updateOutletStatus(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.loadData();
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: 'Status Updated Succesfully',
          });
          this.hideDialog();
          this.activityRecordService.activityRecord(this.userId, 'Update STP Status', reqBody?.Auto_ID, new Date(), 'Success');
        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.userId, 'Update STP Status', reqBody?.Auto_ID, new Date(), err);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    this.loader.start();
    this._personalDetalSer.uploadFile(data, this.userId, formcontrol).subscribe(
      (resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.updateStatusForm.patchValue({ [formcontrol]: resp.data });
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File Uploaded with Auto Mode',
          });
        }else{
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Oops! Someting went wrong.',
          });
        }
      },
      (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    );

    uploadElement.clear();
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  // downloadSheetAsPdf(modelData, filename) {
  //   this.cols = [
  //     { field: 'appID', header: 'APP ID' },
  //     { field: 'FarmerName', header: 'Farmer Name' },
  //     { field: 'village', header: 'Village' },
  //     { field: 'block', header: 'Block' },
  //     { field: 'district', header: 'District' },
  //     { field: 'AgeOfApplication', header: 'Age Of Application' },
  //     { field: 'ProgrammeName', header: 'Programme Name' },
  //     { field: 'LandDetail', header: 'Land Detail' },
  //     { field: 'Total_Area', header: 'Total Area' },
  //     { field: 'PendingCompletedDays', header: 'Pending Completed Days' },
  //     { field: 'Status_Ar', header: 'Current Status' },
  //     { field: 'status', header: 'Status' },
  //     { field: 'DeptRemarks', header: 'Dept Remarks' },
  //   ];

  //   this.exportColumns = this.cols.map((col) => ({
  //     title: col.header,
  //     dataKey: col.field,
  //   }));

  //   import('jspdf').then((jsPDF) => {
  //     import('jspdf-autotable').then((x) => {
  //       const doc = new jsPDF.default(0, 0);
  //       doc.autoTable(this.exportColumns, this.canalMasterData);
  //       doc.save('Applications_Details.pdf');
  //     });
  //   });
  // }
  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Type":d.Type,
          "Water Course Name":d.Canal,
          "RD":d.RD,
          "Total Apps":d.TotalApps,
          "Constituency":d.Constituency,
          "Block":d.Block,
          "Circle Name":d.CircleName,
          "Divison Name":d.Divison_Name,
          "District":d.District,
          "Village":d.Village,
          "CCA":d.CCA,
          "Office Number":d.Office_Number,
          "Area Acre":d.AreaAcre,
          "Document ID":d.documentID,  
          "Start date":d.fromDate,  
          "End Date":d.endDate,  
          "Current Status":d.CurrentStatus,    

        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Type', header: 'Type' },
      { field: 'Canal', header: 'Water Course Name' },
      { field: 'RD', header: 'RD' },
      { field: 'TotalApps', header: 'Total Apps' },
      { field: 'Constituency', header: 'Constituency' },
      { field: 'Block', header: 'Block' },
      { field: 'CircleName', header: 'Circle Name' },
      { field: 'Divison_Name', header: 'Divison Name' },
      { field: 'District', header: 'District' },
      { field: 'Village', header: 'Village' },
      { field: 'CCA', header: 'CCA' },
      { field: 'Office_Number', header: 'Office Number' },
      { field: 'AreaAcre', header: 'Target Area' },
      { field: 'documentID', header: 'Document ID' },
      { field: 'fromDate', header: 'Start Date' },
      { field: 'endDate', header: 'End Date' },
      { field: 'CurrentStatus', header: 'Current Status' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.canalMasterData);
        doc.save('Applications_Details.pdf');
      });
    });
  }

  refreshTable() {
    this.loadData();
  }
}
